import React, { createContext, useContext } from 'react';
import useWebSocket from '../hooks/useWebSocket';
import { useAuth } from './AuthContext';

const WebSocketContext = createContext(null);

export function WebSocketProvider({ children }) {
  const { token } = useAuth();

  // Build WebSocket URL from the API base URL
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';
  const wsProtocol = apiUrl.startsWith('https') ? 'wss' : 'ws';
  const wsHost = apiUrl.replace(/^https?:\/\//, '').replace(/\/api$/, '');
  const wsUrl = token ? `${wsProtocol}://${wsHost}/ws` : null;

  const ws = useWebSocket(wsUrl, token);

  return (
    <WebSocketContext.Provider value={ws}>
      {children}
    </WebSocketContext.Provider>
  );
}

export function useWS() {
  const ctx = useContext(WebSocketContext);
  if (!ctx) {
    // Return a no-op fallback if used outside provider
    return { isConnected: false, subscribe: () => () => {}, sendMessage: () => {} };
  }
  return ctx;
}
